import React, { useState, useEffect } from 'react';
import {useHistory, useParams} from 'react-router-dom';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {
  Breadcrumbs, Button, Container, FormControl, FormControlLabel, ListItem, Paper, Radio, RadioGroup,
  Typography,
} from "@mui/material";
import {
  getNextStep,
  getPreviousStep,
  getStepFromUrl,
  requestApi,
  restartBooking,
  showAlertAutoDis
} from "../../utils/utils";
import {useDispatch, useSelector} from "react-redux";
import Grid from "@mui/material/Grid";
import {setStep} from "../../redux/actions/stepActions";
import Itinerary from "../../components/Booking/DayTripBooking/Itinerary";
import ActivityBookingReview from "../../components/Booking/DayTripBooking/ActivityBookingReview";
import DayTripStepper from "../../components/Booking/DayTripBooking/DayTripStepper";
import {setBookingType} from "../../redux/actions/tripActions";
import {SET_SELECTED_EXTRAS} from "../../redux/constants/transactionConstants";
import {setTotalActivitiesFH} from "../../redux/actions/totalActions";
import {getActivityList} from "../../redux/actions/activitiesActions";


const DayTripConfirmationPage = ({history}) => {
  const prefix = window['siteUrl'];
  const confirmationBanner = prefix + '/images/confirmation/banner.jpg';
  const dispatch = useDispatch();
  const {bookingId} = useParams();
  const [booking, setBooking] = useState({})
  const transactions = useSelector(state => state.transactions);
  const step = useSelector(state => state.step);
  const prefixUrl = 'booking/day-trips';
  const historyUrl = useHistory();
  const prevStep = getPreviousStep(step);
  const bookingType = useSelector(state => state.bookingType);
  const totals = useSelector((state) => state.totalsExtras);

  useEffect(() => {
    const stepNum = getStepFromUrl(history.location.pathname);
    dispatch(setStep(stepNum));
    if (Object.keys(booking).length === 0)
      getBooking().catch();
  }, []);

  async function getBooking() {
    const {data} = await requestApi(`/activities/booking/get/${bookingId}`);
    if ('status' in data && data['status'] === 'success') {
      if (Object.keys(data['booking']).length > 0) {
        setBooking(data['booking']);
      }
      if (Object.keys(data['transactions']).length > 0)
        sessionStorage.setItem('transactions', JSON.stringify(data['transactions']));
    }
  }

  const goBack = () => {
      historyUrl.push(`/${prefixUrl}/${bookingId}${prevStep.url}`);
  };

  const goToMyBookings = () => {
      history.push(`/booking/my-bookings`);
  };


  return (
      <>
        <GuestBar>
          <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
            <Typography color="text.primary">Day Trip Bookings - Confirmation</Typography>
          </Breadcrumbs>
        </GuestBar>

        <Container maxWidth="lg">
          <DayTripStepper/>
          <div style={{marginTop: 50}}/>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={9}>
                  <div style={{
                    backgroundImage: `url("${confirmationBanner}")`,
                    backgroundPositionY: 'center',
                    marginBottom: 20,
                    minHeight: 200,
                  }} className={'confirmationBanner'}/>
                  <Typography align={'center'} id="transition-modal-title" variant={'h3'} style={{marginBottom:20}}>
                    Booking Confirmation #{booking.Confirmation}
                  </Typography>
                  <ActivityBookingReview showClientRef={false}/>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Paper style={{marginTop: 20}}>
                    <Button color={'primary'} variant={'contained'} fullWidth onClick={goToMyBookings}>
                      Go to My Bookings
                    </Button>
                    {/*<Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>*/}
                    {/*  Go Back to {prevStep.label}*/}
                    {/*</Button>*/}
                  </Paper>
                  <Itinerary removable={false}/>
                </Grid>
              </Grid>
        </Container>
      </>
  );
};

export default DayTripConfirmationPage;
